import { render, staticRenderFns } from "./sourceModal.vue?vue&type=template&id=ba08623a&scoped=true"
import script from "./sourceModal.vue?vue&type=script&lang=js"
export * from "./sourceModal.vue?vue&type=script&lang=js"
import style0 from "./sourceModal.vue?vue&type=style&index=0&id=ba08623a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba08623a",
  null
  
)

export default component.exports